module.exports = "<div>\n    Bientôt !\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/pages/statistic/statistic.component.html
// module id = 755
// module chunks = 1